// GLOBAL JS
// MOBILE MENU OPEN - HAMBURGER ANIMATION
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('hamburger-toggle');
  const mobileNav = document.getElementById('mobile-menu');
  const htmlElement = document.documentElement;

  mobileNav.classList.add('menu-loaded');
  
  menuToggle.addEventListener('click', function() {
    mobileNav.classList.toggle('active');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('active-close');
    htmlElement.classList.toggle('overflow-hidden');
  });
});

// Localization form JavaScript
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// FIX THIS AS IT FUCKS WITH NON ANCHOR TAG LINKS
// Smooth scroll and removing the #tag from the URL Bar
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    document.querySelector(targetId).scrollIntoView({
      behavior: 'smooth'
    });

    // Remove the hash from URL after scrolling
    history.pushState("", document.title, window.location.pathname + window.location.search);
  });
});

// Getting header height
function setHeaderHeightVariable() {
  const headerSections = document.querySelectorAll(".shopify-section-group-header-group");
  
  if (headerSections.length > 0) {
    const root = document.documentElement;
    let totalHeight = 0;
    
    headerSections.forEach(section => {
      totalHeight += section.offsetHeight;
    });
    
    root.style.setProperty('--header-group-height', totalHeight + "px");
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', setHeaderHeightVariable);

// Run on window resize to handle responsive changes
window.addEventListener('resize', debounce(setHeaderHeightVariable, 100));

// Debounce function to limit resize event calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Global Accordion System
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      const accordionItem = header.closest('.accordion-item');
      const content = accordionItem.querySelector('.accordion-content');
      const isOpen = accordionItem.classList.contains('open');

      // Close other open accordions
      document.querySelectorAll('.accordion-item.open').forEach(function(openItem) {
        if (openItem !== accordionItem) {
          closeAccordion(openItem);
        }
      });

      // Toggle current accordion
      if (!isOpen) {
        openAccordion(accordionItem, header, content);
      } else {
        closeAccordion(accordionItem);
      }
    });

    // Keyboard accessibility
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  function openAccordion(item, header, content) {
    item.classList.add('open');
    header.setAttribute('aria-expanded', 'true');
    content.style.maxHeight = content.scrollHeight + "px";
  }

  function closeAccordion(item) {
    item.classList.remove('open');
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    
    if (header) header.setAttribute('aria-expanded', 'false');
    if (content) content.style.maxHeight = '0';
  }
});
  
// Format Monies
function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.money_format || "{{amount}}";

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
  }
  return formatString.replace(placeholderRegex, value);
}
Shopify = Shopify || {};
Shopify.formatMoney = formatMoney;